var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVet6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "150.000000pt",
    height: "150.000000pt",
    viewBox: "0 0 150.000000 150.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,150.000000) scale(0.100000,-0.100000)",
    fill: "#D00202",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552 1477 c-6 -7 -12 -42 -14 -77 l-3 -64 -121 -21 c-165 -29 -157 -24 -149 -88 l7 -52 -116 -38 c-178 -59 -172 -30 -72 -306 47 -128 88 -236 91 -239 3 -3 10 -1 16 5 8 8 -11 72 -69 235 -67 187 -78 224 -65 231 8 5 60 24 116 43 105 35 116 34 117 -10 0 -10 11 -79 24 -155 14 -75 48 -271 76 -436 57 -336 56 -331 73 -338 7 -3 102 11 212 29 109 19 203 33 209 31 7 -2 -370 -143 -460 -171 -19 -6 -27 11 -105 230 -76 214 -98 259 -116 240 -8 -8 167 -493 183 -507 10 -8 84 15 296 91 156 56 326 117 378 137 91 35 102 36 258 42 129 5 165 9 172 21 6 9 10 213 10 500 l0 485 -104 98 -105 97 -364 0 c-285 0 -367 -3 -375 -13z m698 -91 c0 -36 4 -76 10 -90 9 -24 13 -25 102 -28 l93 -3 3 -467 2 -468 -440 0 -440 0 -2 223 c-3 189 -5 222 -18 222 -13 0 -15 -33 -18 -230 -2 -207 -1 -231 15 -242 12 -9 74 -13 217 -14 l201 -1 -95 -18 c-293 -56 -393 -71 -401 -59 -4 7 -10 33 -14 58 -3 25 -17 107 -30 181 -51 289 -135 786 -135 797 0 6 41 18 93 27 50 9 104 19 120 22 l27 6 0 -227 c0 -210 1 -226 18 -223 16 3 17 27 20 301 l2 297 335 0 335 0 0 -64z m114 -13 c33 -31 63 -60 64 -65 2 -4 -28 -8 -67 -8 l-71 0 0 65 c0 36 3 65 6 65 4 0 34 -25 68 -57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694 1159 c-3 -6 -2 -15 3 -20 5 -5 142 -8 329 -7 294 3 319 4 322 21 3 16 -17 17 -322 17 -223 0 -327 -3 -332 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 995 c0 -13 43 -15 330 -15 287 0 330 2 330 15 0 13 -43 15 -330 15 -287 0 -330 -2 -330 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695 850 c-17 -27 16 -30 331 -30 305 0 325 1 322 18 -3 16 -28 17 -325 20 -209 1 -324 -1 -328 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697 693 c-4 -3 -7 -10 -7 -15 0 -4 149 -8 330 -8 287 0 330 2 330 15 0 13 -43 15 -323 15 -178 0 -327 -3 -330 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692 528 c4 -10 81 -14 331 -16 287 -2 327 0 327 13 0 13 -42 15 -331 15 -260 0 -330 -3 -327 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet6);
export default __webpack_public_path__ + "static/media/vet-6.08c8ae12ab37af2710193d8bd8f6cc00.svg";
export { ForwardRef as ReactComponent };